import {
  Card,
  CrudMode,
  DataDisplay,
  formatDate,
  Grid,
  newToast,
  Stack,
  Typography,
  useElementBreakpoints,
} from "@compass/core";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { SubmitButton } from "components";
import { CopyLinkButton } from "components/common/CopyLinkButton";
import { UserDto } from "generated/openApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const Support = (props: {
  crudMode: CrudMode;
  userDto: UserDto;
  setUserDto: (value: UserDto) => void;
  reroute: (userMembership: string, crudMode: CrudMode) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [invitationLink, setInvitationLink] = useState<string>();
  const [linkCopy, setLinkCopy] = useState(false);
  const [sendingInvitationEmail, setSendingInvitationEmail] = useState(false);
  const dispatch = useDispatch();
  const user = props.userDto.user;

  useEffect(() => {
    setLinkCopy(false);

    if (!user?.id) {
      setInvitationLink(undefined);
      return;
    }

    ApiService.users.getInvitationLink(user.id).then(setInvitationLink);
  }, [user?.id]);

  const resendInvitationEmail = () => {
    if (!user?.id) return;

    setSendingInvitationEmail(true);
    ApiService.users
      .sendInvitationEmail(user.id)
      .then((membership) => Promise.all([
        Promise.resolve(membership),
        ApiService.users.getByUserMembership(membership),
        ApiService.users.getInvitationLink(user.id),
      ]))
      .then(([membership, userDto, link]) => {
        props.setUserDto(userDto);
        setInvitationLink(link);
        props.reroute(membership, props.crudMode);
        dispatch(setAppToast(newToast("success")));
      })
      .catch(() => {
        dispatch(setAppToast(newToast("error")));
      })
      .finally(() => setSendingInvitationEmail(false));
  };

  return (
    <Card
      header={
        <Stack direction="row" alignItems="center">
          <SupportAgentOutlinedIcon />
          <Typography variant="inherit" paddingLeft="5px">
            Support
          </Typography>
        </Stack>
      }
      fullHeight
    >
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={12}>
          <Grid direction="row" container spacing="lg" alignItems="center">
            <Grid item xs={11}>
              <DataDisplay label="Registration Link">{invitationLink}</DataDisplay>
            </Grid>
            <Grid item xs={1}>
              {invitationLink && (
                <CopyLinkButton copyLink={invitationLink} showCheck={linkCopy} setShowCheck={setLinkCopy} />
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          <DataDisplay label="Is Registered">
            {user?.isApproved === undefined ? undefined : `${user.isApproved}`}
          </DataDisplay>
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          <DataDisplay label="Last Logged On">{formatDate(user?.lastLoginDate)}</DataDisplay>
        </Grid>

        {user?.isApproved === false && (
          <Grid item xs={12}>
            <SubmitButton
              label="Resend Invitation Email"
              onClick={resendInvitationEmail}
              disabled={sendingInvitationEmail}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};
